module.exports = __webpack_public_path__ + "img/katarina_amenities_13.e1b4d5b5.jpg";